import { Box, SimpleGrid, Text, VStack } from "@chakra-ui/react";

const BRAND = "#C41E3A";

const FIELDS = [
  { key: "storeId", label: "Store ID" },
  { key: "customerId", label: "Customer ID" },
  { key: "storeName", label: "Store Name" },
  { key: "storeTypeClass", label: "Store Type-Class" },
];

const getFieldValue = (storeDetail, key) => {
  if (key === "storeTypeClass") {
    const { storeType, storeClass } = storeDetail;
    if (!storeType && !storeClass) return "—";
    return `${storeType ?? "—"}-${storeClass ?? "—"}`;
  }
  return storeDetail[key] ?? "—";
};

export function StoreInfoPanel({ storeDetail }) {
  if (!storeDetail) return null;

  return (
    <Box
      bg="white" borderRadius="2xl" boxShadow="sm"
      border="1px solid" borderColor="gray.200"
      p={5} mb={6}
    >
      <SimpleGrid columns={{ base: 3, sm: 4, lg: 4 }} spacing={10}>
        {FIELDS.map(({ key, label }) => (
          <VStack key={key} align="flex-start" spacing={0}>
            <Text
              fontSize="10px" fontWeight="900" color="gray.400"
              textTransform="uppercase" letterSpacing="wider"
            >
              {label}
            </Text>
            <Text
              fontSize="sm" fontWeight="700" color="gray.800"
              whiteSpace="normal" wordBreak="break-word"
            >
              {getFieldValue(storeDetail, key)}
            </Text>
          </VStack>
        ))}
      </SimpleGrid>
    </Box>
  );
}